module.exports = __webpack_public_path__ + "static/media/event-hero.c8cbd457.png";